import { create } from 'zustand';

export const useCommonEnumStore = create((set) => ({
  commonEnum: {},
  update: (val) => set({ commonEnum: val }),
}));
export const useCommonEnum = (enumName) =>
  useCommonEnumStore((state) => [enumName ? state.commonEnum[enumName] : state.commonEnum, state.update]);
